<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
  <mat-drawer-container [hasBackdrop]="false">
    <mat-drawer [mode]="drawerMode" [opened]="false" [position]="'end'" [disableClose]="false" #matDrawer>
      <router-outlet></router-outlet>
    </mat-drawer>
    <mat-drawer-content>
      <div class="main">
        <div class="list-wrapper">
          <!-- Header -->
          <div class="header">
            <!-- Title -->
            <div class="title flex flex-auto flex-row">
              <button class="sidebar-toggle" mat-icon-button (click)="projectTenantsComponent.drawer.toggle()">
                <mat-icon [svgIcon]="'menu'"></mat-icon>
              </button>
              <div class="flex flex-auto flex-row items-center">
                <h1>{{ property?.name || property.address?.address_string }}</h1>
                <button mat-icon-button type="button" [matMenuTriggerFor]="tableInfo">
                  <mat-icon class="icon-size-20" [svgIcon]="'heroicons_outline:light-bulb'"></mat-icon>
                </button>
                <mat-menu #tableInfo="matMenu">
                  <table cellpadding="5" class="m-2 text-left">
                    <tr>
                      <th>LCD</th>
                      <td>Lease Start Date</td>
                    </tr>
                    <tr>
                      <th>LED</th>
                      <td>Lease End Date</td>
                    </tr>
                    <tr>
                      <th>OED</th>
                      <td>Occupancy End Date</td>
                    </tr>
                    <tr>
                      <th>BMR</th>
                      <td>Base Monthly Rent</td>
                    </tr>
                    <tr>
                      <th>PSF</th>
                      <td>Per sq. ft.</td>
                    </tr>
                  </table>
                </mat-menu>
              </div>
            </div>

            <!-- Main actions -->
            <div class="main-actions">
              <mat-form-field class="treo-mat-dense treo-mat-no-subscript mr-3">
                <mat-icon matPrefix [svgIcon]="'search'"></mat-icon>
                <input matInput [formControl]="searchInputControl" [placeholder]="'Search...'" />
              </mat-form-field>
              <!-- <button class="mx-2 xs:hidden add-contact" mat-stroked-button>
                                <mat-icon class="icon-size-20 rotate-90 mirror" [svgIcon]="'import_contacts'">
                                </mat-icon>
                                Import
                            </button> -->
              <!-- Add contact button -->
              <button class="add-contact" mat-flat-button [color]="'primary'" (click)="addUnit()">
                <mat-icon [svgIcon]="'add'"></mat-icon>
                Add Suite/Unit
              </button>
            </div>
            <div class="loader" *ngIf="isLoading">
              <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
            </div>
          </div>

          <!-- Contacts list -->
          <div class="contacts-list">
            <div class="table-wrapper">
              <div class="inline-table-wrapper">
                <ng-container>
                  <!-- Table -->
                  <table
                    mat-table
                    matSort
                    [matSortActive]="'name'"
                    [matSortDisableClear]="true"
                    [matSortDirection]="'asc'"
                    [dataSource]="propertyUnitsDataSource"
                    [trackBy]="trackByFn"
                  >
                    <!-- Name -->
                    <ng-container matColumnDef="unit_number">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Unit Number</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <app-editable
                          [fieldDef]="unitNumberFieldDef"
                          [model]="propertyUnit"
                          (onUpdate)="onUpdatePropertyUnit($event, propertyUnit)"
                        ></app-editable>
                      </td>
                    </ng-container>

                    <!-- Email -->
                    <ng-container matColumnDef="unit_size">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Unit Size (Sq. Ft.)</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <app-editable
                          [fieldDef]="unitSizeFieldDef"
                          [model]="propertyUnit"
                          (onUpdate)="onUpdatePropertyUnit($event, propertyUnit)"
                        ></app-editable>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="floor">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Floor</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <app-editable
                          [fieldDef]="unitFloorFieldDef"
                          [model]="propertyUnit"
                          (onUpdate)="onUpdatePropertyUnit($event, propertyUnit)"
                        ></app-editable>
                      </td>
                    </ng-container>

                    <!-- Phone number -->
                    <ng-container matColumnDef="name">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Tenant Name</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <ng-container *ngIf="propertyUnit.property_tenant">
                          <app-editable
                            [fieldDef]="tenantNameFieldDef"
                            [model]="propertyUnit.property_tenant"
                            (onUpdate)="onUpdatePropertyTenant($event, propertyUnit, propertyUnit.property_tenant)"
                            [showEmptyHolder]="true"
                          ></app-editable>
                        </ng-container>
                      </td>
                    </ng-container>

                    <!-- Phone number -->
                    <ng-container matColumnDef="lease_start_date">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>LCD</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <ng-container *ngIf="propertyUnit.property_tenant">
                          <app-editable
                            [fieldDef]="tenantLeaseStartDateFieldDef"
                            [model]="propertyUnit.property_tenant"
                            (onUpdate)="onUpdatePropertyTenant($event, propertyUnit, propertyUnit.property_tenant)"
                            [showEmptyHolder]="true"
                          ></app-editable>
                        </ng-container>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="lease_end_date">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>LED</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <ng-container *ngIf="propertyUnit.property_tenant">
                          <app-editable
                            [fieldDef]="tenantLeaseEndDateFieldDef"
                            [model]="propertyUnit.property_tenant"
                            (onUpdate)="onUpdatePropertyTenant($event, propertyUnit, propertyUnit.property_tenant)"
                            [showEmptyHolder]="true"
                          ></app-editable>
                        </ng-container>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="occupancy_end_date">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>OED</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <ng-container *ngIf="propertyUnit.property_tenant">
                          <app-editable
                            [fieldDef]="tenantOccupancyEndDateFieldDef"
                            [model]="propertyUnit.property_tenant"
                            (onUpdate)="onUpdatePropertyTenant($event, propertyUnit, propertyUnit.property_tenant)"
                            [showEmptyHolder]="true"
                          ></app-editable>
                        </ng-container>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="base_monthly_rent">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>BMR</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <ng-container *ngIf="propertyUnit.property_tenant">
                          <app-editable
                            [fieldDef]="tenantBaseMonthlyRentFieldDef"
                            [model]="propertyUnit.property_tenant"
                            (onUpdate)="onUpdatePropertyTenant($event, propertyUnit, propertyUnit.property_tenant)"
                            [showEmptyHolder]="true"
                          ></app-editable>
                        </ng-container>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="percentage_rent">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>% Rent</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <ng-container *ngIf="propertyUnit.property_tenant">
                          <app-editable
                            [fieldDef]="tenantPercentageRentFieldDef"
                            [model]="propertyUnit.property_tenant"
                            (onUpdate)="onUpdatePropertyTenant($event, propertyUnit, propertyUnit.property_tenant)"
                            [showEmptyHolder]="true"
                          ></app-editable>
                        </ng-container>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="sales">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Sales</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <ng-container *ngIf="propertyUnit.property_tenant">
                          <app-editable
                            [fieldDef]="tenantSalesFieldDef"
                            [model]="propertyUnit.property_tenant"
                            (onUpdate)="onUpdatePropertyTenant($event, propertyUnit, propertyUnit.property_tenant)"
                            [showEmptyHolder]="true"
                          ></app-editable>
                        </ng-container>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="gross_rent">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Gross Rent</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <ng-container *ngIf="propertyUnit.property_tenant">
                          {{ propertyUnit.property_tenant.gross_rent | tsCurrency: 'USD':'symbol':'1.0' }}
                        </ng-container>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="price_per_sq_ft">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>PSF</th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <ng-container *ngIf="propertyUnit.property_tenant">
                          <!-- {{propertyUnit.property_tenant.price_per_sq_ft | tsCurrency:'USD':'symbol':'1.0'}} -->
                          <app-editable
                            [fieldDef]="pricePerSqFtDef"
                            [model]="propertyUnit.property_tenant"
                            (onUpdate)="onUpdatePropertyTenant($event, propertyUnit, propertyUnit.property_tenant)"
                            [showEmptyHolder]="true"
                          ></app-editable>
                        </ng-container>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let propertyUnit">
                        <a [routerLink]="[propertyUnit.id]" class="placeholder">
                          <mat-icon [svgIcon]="'chevron_right'"></mat-icon>
                        </a>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="tenantTableColumns"></tr>
                    <tr class="contact-row" mat-row *matRowDef="let row; columns: tenantTableColumns"></tr>
                  </table>
                </ng-container>
              </div>
              <div class="footer-section flex justify-between items-center pl-30"></div>
              <ng-template #noPropertyUnits>
                <div class="no-contacts">There are no tenants!</div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
